module.exports = __webpack_public_path__ + "6daef54f953252b5f5107d83d0776a78.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_bar_1day_show_labels.png
// module id = 853
// module chunks = 7